import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormProvider, useForm } from "react-hook-form";
import { PaziaInput } from "components/atoms";
import { PaziaFormButton } from "components/atoms";
import { PaziaBox } from "components/atoms";

const schema = yup
  .object({
    name: yup.string().required(),
  })
  .required();
export type FinanceCategoryFormValues = yup.InferType<typeof schema>;

interface FinanceCategoryFormProps {
  onSubmit: (data: FinanceCategoryFormValues) => void;
  name?: string;
}
export const FinanceCategoryForm = ({ onSubmit, name }: FinanceCategoryFormProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    values: {
      name: name ?? "",
    },
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <PaziaBox>
        <form onSubmit={handleSubmit(onSubmit)} className="grid max-w-xl gap-2">
          <PaziaInput name="name" label="Nazwa" type="text" />

          <div className="pt-4">
            <PaziaFormButton title="Zapisz" type="success" />
          </div>
        </form>
      </PaziaBox>
    </FormProvider>
  );
};
